import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { HelpContextualInfo } from '@model';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, skip } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import * as fromHelpStore from '@appStore/help';

@Component({
    selector: 'app-help-contextual-info',
    templateUrl: './help-contextual-info.component.html',
    standalone: false
})
export class HelpContextualInfoComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  contextualInfoData: HelpContextualInfo[];
  @Input()
  currentContextualInfoData: HelpContextualInfo;

  contextualInfoDisplay: HelpContextualInfo[];
  routeSubscription: Subscription;
  currentUrl = '';
  selectedTab = '';

  private subs = new SubSink();

  constructor(private router: Router, private store: Store<fromHelpStore.State>) {}

  ngOnInit() {
    this.contextualInfoDisplay = [] as HelpContextualInfo[];

    if (this.router) {
      this.currentUrl = window.location.pathname;
      this.filterItems(); 

      this.subs.sink = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(routeEvent => {
          if (routeEvent && routeEvent['url'] && routeEvent['url'] !== this.currentUrl) {
            this.currentUrl = routeEvent['url'];
            this.filterItems();
          }
        });

      this.subs.sink = this.store
        .select(fromHelpStore.getSelectedTab)
        .pipe(filter(x => !!x))
        .subscribe(selectedTab => {
          this.selectedTab = selectedTab;
          this.filterItems();
        });
    }
  }

  ngOnChanges() {
    this.filterItems();
  }

  ngOnDestroy() {
    // Remove override of ContextualInfo
    this.store.dispatch(new fromHelpStore.HelpClearContextualInfo());
    this.subs.unsubscribe();
  }

  filterItems() {
    if(this.currentContextualInfoData) {
      this.contextualInfoDisplay = [] as HelpContextualInfo[];
      this.contextualInfoDisplay.push(this.currentContextualInfoData);

    } else if (this.contextualInfoData) {
      this.contextualInfoDisplay = this.contextualInfoData.filter(this.isRegMatch);
    } else {
      this.contextualInfoDisplay = [] as HelpContextualInfo[];
    }
  }
  isRegMatch = (ci: HelpContextualInfo): boolean => {
    let qParamMatch = false;
    let result = false;
    let routes = ci.route.split(':'); // More than one route to match for context-info

    for (let i = 0; i < routes.length; i++) {
      let route = routes[i];
      let parts = route.split('?tab=');
      if (parts.length > 1) {
        let qParam = parts[1];
        if (this.selectedTab === qParam) {
          qParamMatch = true;
        } else {
          qParamMatch = false;
        }
      } else {
        qParamMatch = true;
      }
      let pattern = parts[0].replace('/', '\\/');
      // let  fetch $xxx params
      let regEx = new RegExp(pattern + '\\/?$');
      result = regEx.test(this.currentUrl) && qParamMatch;
      if (result) {
        break; // Exit loop
      }
    }

    return result;
  };
}
